<!-- Premium Footer -->
<footer class="relative bg-primary text-white overflow-hidden">
	<!-- Decorative Elements -->
	<div class="absolute inset-0 opacity-5">
		<div class="absolute top-0 left-1/4 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
		<div class="absolute bottom-0 right-1/4 w-96 h-96 bg-charcoal rounded-full blur-3xl"></div>
	</div>

	<!-- Animated Top Border -->
	<div class="h-1 bg-gradient-to-r from-transparent via-secondary to-transparent animate-shimmer"></div>

	<div class="relative max-w-[1400px] mx-auto px-6 md:px-8 lg:px-12">
		<!-- Main Footer Content -->
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 py-16 md:py-20">
			<!-- Brand Section -->
			<div class="space-y-6">
				<app-logo [variant]="'light'" [size]="'sm'" [isLink]="false" [showShadow]="false"></app-logo>
				<p class="text-white/70 text-sm leading-relaxed">
					Transform your confidence with world-class hair restoration services. Expert care, natural results.
				</p>
				<!-- Social Links -->
				<div class="flex items-center gap-4">
					@for (social of socialLinks; track social.name) {
						<a
							[href]="social.url"
							target="_blank"
							class="group w-10 h-10 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center hover:bg-gradient-to-br hover:from-primary hover:to-secondary hover:border-transparent transition-all duration-300 hover:scale-110">
							@if (social.icon === 'facebook') {
								<svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
									<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
								</svg>
							}
							@if (social.icon === 'instagram') {
								<svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
									<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
								</svg>
							}
							@if (social.icon === 'twitter') {
								<svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
									<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
								</svg>
							}
							@if (social.icon === 'linkedin') {
								<svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
									<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
								</svg>
							}
						</a>
					}
				</div>
			</div>

			<!-- Quick Links -->
			<div>
				<h3 class="text-lg font-bold mb-6 text-white relative inline-block">
					Quick Links
					<span class="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-secondary to-transparent"></span>
				</h3>
				<ul class="space-y-3">
					@for (link of quickLinks; track link.name) {
						<li>
							<a [href]="link.route" class="group flex items-center gap-2 text-white/70 hover:text-secondary transition-colors duration-300">
								<svg class="w-4 h-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
								</svg>
								<span>{{ link.name }}</span>
							</a>
						</li>
					}
				</ul>
			</div>

			<!-- Services -->
			<div>
				<h3 class="text-lg font-bold mb-6 text-white relative inline-block">
					Our Services
					<span class="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-secondary to-transparent"></span>
				</h3>
				<ul class="space-y-3">
					@for (service of services; track service.name) {
						<li>
							<a [href]="service.route" class="group flex items-center gap-2 text-white/70 hover:text-secondary transition-colors duration-300">
								<svg class="w-4 h-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
								</svg>
								<span>{{ service.name }}</span>
							</a>
						</li>
					}
				</ul>
			</div>

			<!-- Contact Info -->
			<div>
				<h3 class="text-lg font-bold mb-6 text-white relative inline-block">
					Contact Us
					<span class="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-secondary to-transparent"></span>
				</h3>
				<ul class="space-y-4">
					<li class="flex items-start gap-3">
						<div class="flex-shrink-0 w-10 h-10 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center">
							<svg class="w-5 h-5 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
							</svg>
						</div>
						<div>
							<p class="text-white/50 text-xs mb-1">Phone</p>
							<a [href]="'tel:' + contactPhone()" class="text-white hover:text-secondary transition-colors duration-300">{{ contactPhone() }}</a>
						</div>
					</li>
					<li class="flex items-start gap-3">
						<div class="flex-shrink-0 w-10 h-10 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center">
							<svg class="w-5 h-5 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
							</svg>
						</div>
						<div>
							<p class="text-white/50 text-xs mb-1">Email</p>
							<a [href]="'mailto:' + contactEmail()" class="text-white hover:text-secondary transition-colors duration-300 break-all">{{ contactEmail() }}</a>
						</div>
					</li>
					<li class="flex items-start gap-3">
						<div class="flex-shrink-0 w-10 h-10 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center">
							<svg class="w-5 h-5 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
							</svg>
						</div>
						<div>
							<p class="text-white/50 text-xs mb-1">Location</p>
							<a href="#map-div" class="text-white hover:text-secondary transition-colors duration-300 text-sm cursor-pointer">
								{{ contactAddressLine1() }}<br/>
								{{ contactAddressLine2() }}
							</a>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<!-- Bottom Bar -->
		<div class="border-t border-white/10 py-8">
			<div class="flex flex-col md:flex-row items-center justify-between gap-4">
				<p class="text-white/60 text-sm text-center md:text-left">
					© {{ currentYear }} OG Hair Studio. All rights reserved.
				</p>
				<p class="text-white/50 text-sm flex items-center gap-1.5">
					Developed with
					<svg class="w-4 h-4 text-red-500 animate-pulse" fill="currentColor" viewBox="0 0 24 24">
						<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
					</svg>
					by
					<a href="https://samchitech.com" target="_blank" class="text-secondary hover:text-white transition-colors duration-300 font-medium">
						SamchiTech
					</a>
				</p>
				<div class="flex items-center gap-6">
					<a href="/privacy-policy" class="text-white/60 hover:text-secondary text-sm transition-colors duration-300">
						Privacy Policy
					</a>
					<a href="/terms" class="text-white/60 hover:text-secondary text-sm transition-colors duration-300">
						Terms of Service
					</a>
				</div>
			</div>
		</div>
	</div>
</footer>

